// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__34dqs","title":"Info_title__1Lq-1","links":"Info_links__1FGQc","link":"Info_link__26nkr","logo":"Info_logo__3Cfsa"};